export class AppConfig{
    static isPro = true
    static all = 24
    static span = 23
    static span22 = 22
    static color = '#1b57ec'

    static route_home = '/'
    static route_cpCredit = '/cpCredit'
    static route_cpPromotion = '/cpPromotion'
    static route_cpDemo = '/cpDemo'
    static route_about = '/about'
}
